import React from 'react'
import { Col, Form, Row } from 'antd'
import { DeleteFilled, PlusCircleFilled } from '@ant-design/icons'
import { FormNumberInput } from '@components/_SiteWide/Form/FormNumberInput'
import { DropdownSelect } from '@components/_SiteWide/Form/DropdownSelect'

export const BlendComponentPercentage = ({ components, products, canEditBlends, editable = false }) => {
  const alignPercent = editable ? '' : 'right'
  const elementSpan = editable ? 11 : 12

  return (
    <Form.List style={{ height: '100%' }} name='components'>
      {(fields, { add, remove }) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center' }}>
            {fields.map((field, index) => (
              <Row style={{ height: '100%' }} key={index} className='blend-component-percent-row'>
                <Col className='blend-component-percent-col vertical-flex-center' span={elementSpan}>
                  <DropdownSelect
                    options={products}
                    showSearch
                    initialValue={components[index] ? components[index].name : ''}
                    editable={editable}
                    required
                    name={[index, 'name']}
                    width='100%'
                    message='Product is Required'
                    placeholder=''
                  />
                </Col>
                <Col
                  className='blend-component-percent-col vertical-flex-center'
                  span={elementSpan}
                  align={alignPercent}
                >
                  <FormNumberInput
                    initialValue={components[index] ? components[index].percentage : ''}
                    editable={editable}
                    required
                    size='default'
                    name={[index, 'percentage']}
                    width='100%'
                    message='Percentage is Required'
                    placeholder=''
                  />
                </Col>
                {canEditBlends && editable && (
                  <Col
                    span={2}
                    display='flex'
                    className='pt-2 pl-1'
                    style={{ alignItems: 'center', flexDirection: 'column', height: '100%' }}
                  >
                    {index === 0 && (
                      <PlusCircleFilled
                        className='add-blend-component'
                        onClick={(e) => {
                          add()
                        }}
                      />
                    )}
                    {canEditBlends && index > 0 && (
                      <DeleteFilled
                        className='delete-blend-component'
                        onClick={(e) => {
                          remove(index)
                        }}
                      />
                    )}
                  </Col>
                )}
              </Row>
            ))}
          </div>
        )
      }}
    </Form.List>
  )
}
